<template>
  <div>
    <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="700px"
    center
    destroy-on-close
    >
    <div class="box">
      <h3>{{ formData.name }}</h3>
      <p>
        <i class="el-icon-date"></i>
        <span>{{ formData.created_at }}</span>
        <i class="el-icon-user"></i>
        <span>{{ formData.created_user }}</span>
      </p>
      <p>
        公司：{{ formData.company_name }}
      </p>
       <p>
        地址：{{ formData.address }}
      </p>  
        
        <p> 
        薪资：{{ formData.salary }} {{ formData.salary_unit_description }}
      </p>
      <div v-html="formData.description"></div>
      
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        title: '查看招聘',
        formData: ''
      }
    },
    methods: {
      show(id){
        if(id){
          userInfoAPI.getRecruitDetail(id).then(({
            data
          }) => {
            if (data.code == 0) {
              this.formData = data.data
              this.dialogVisible = true
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              })
            }
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  p{
    margin: 20px 0;
  }
  .el-icon-date,.el-icon-user{
    margin-right: 10px;
    font-size: 16px;
  }
  .el-icon-user{
    margin-left: 30px;
  }
</style>